var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRightSquare4 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2 24.6L28.6971 19.0971C27.7598 18.1598 26.2402 18.1598 25.3029 19.0971L19.8 24.6M27 19.8L27 36.6M51 15L51 39C51 45.6274 45.6274 51 39 51L15 51C8.37258 51 3 45.6274 3 39L3 15C3 8.37258 8.37259 3 15 3L39 3C45.6274 3 51 8.37258 51 15Z",
    stroke: "#FEFEFE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRightSquare4);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/right-square-4.7ddb04c3d31c305c19f4a9138773f8b2.svg";